<div>

  <app-app-dashboard-navigation></app-app-dashboard-navigation>

  <div class="dash-section m-5 p-3 bg-white">
    <div class="m-4">
      <div class="col font-weight-bold text-black-50 ">
        Market-Info
      </div>
      <!-- <div class="col" (click)="showFilter = !showFilter">
        <button class="btn float-right btn-md text-white px-3 filter-orange-bg mt-n4" id="toggleMessage">
          <span *ngIf="!showFilter">Show filter<i class="fas fa-chevron-down"></i></span>
          <span *ngIf="showFilter">Hide filter<i class="fas fa-chevron-up"></i></span>
        </button>
      </div> -->
    </div>
  </div>
  <app-crop-list></app-crop-list>
</div>
